var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _path, _rect7, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 209,
    viewBox: "0 0 159 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154.443,
    y: 114.634,
    width: 38.1949,
    height: 59.0472,
    rx: 15,
    transform: "rotate(153.861 154.443 114.634)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38.1949,
    height: 59.0472,
    rx: 15,
    transform: "matrix(0.897731 0.440543 0.440543 -0.897731 6.8208 113.899)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1421,
    y: 63.6777,
    width: 87.0698,
    height: 120.858,
    rx: 10,
    fill: "#FAF4DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.3775,
    cy: 37.0372,
    r: 37.0372,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145.845,
    y: 138.6,
    width: 38.1949,
    height: 96.2034,
    rx: 15,
    transform: "rotate(69.8544 145.845 138.6)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 151.724,
    y: 95.4436,
    width: 38.1949,
    height: 64.5922,
    rx: 15,
    transform: "rotate(106.027 151.724 95.4436)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 38.1949,
    height: 64.5922,
    rx: 15,
    transform: "matrix(0.276097 0.96113 0.96113 -0.276097 6.8208 95.7006)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8904 159.862L101.045 195.721L82.7648 202.427C74.9874 205.28 66.3696 201.288 63.5164 193.511L60.694 185.817C57.8408 178.04 61.8328 169.422 69.6102 166.569L87.8904 159.862Z",
    fill: "#B7B7B7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 38.1949,
    height: 96.2034,
    rx: 15,
    transform: "matrix(-0.344407 0.93882 0.93882 0.344407 13.6096 139.404)",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5649 160.666L58.4103 196.524L76.6905 203.23C84.468 206.084 93.0858 202.092 95.9389 194.314L98.7613 186.621C101.614 178.843 97.6226 170.225 89.8451 167.372L71.5649 160.666Z",
    fill: "#B7B7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5249 33.7886C89.5671 34.7692 95.2851 36.1422 101.82 33.7886",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.23 50.6829C75.2721 51.6635 80.9901 53.0365 87.525 50.6829",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6353 33.7886C59.8631 34.7692 66.1009 36.1422 73.2298 33.7886",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGrey);
export default __webpack_public_path__ + "static/media/person-grey.de26453b5e39b8fcb7a35fd53badf3a6.svg";
export { ForwardRef as ReactComponent };